<template>
  <div :class="$style['life-experience-pavilion-reservation-table']">
    <wt-paged-table
      :on-request-data="getTableData"
      :total-size="totalNumber"
      :page-size="pageSize"
      ref="table"
      :isAddPageToRouter="true"
      :refresh="false"
      :isOutside="isOutside"
      style="{width: 100%;}"
    >
      <el-table
        :data="tableData"
        stripe
      >
        <el-table-column label="预约场次"  min-width="115">
          <template slot-scope="scope">
            <div>{{ scope.row.date }}</div>
            <div>{{ scope.row.time }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="contactMobile" label="联系人手机号" min-width="100">
        </el-table-column>
        <el-table-column label="票种" min-width="85">
          <template slot-scope="scope">
            <div v-for="(visitor, index) in scope.row.visitors" :key="index">
              <div :class="{'visitor-item':index!==0}">{{ visitor.visitorTypeName }} {{ visitor.priceText }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="姓名" min-width="70">
          <template slot-scope="scope">
            <div v-for="(visitor, index) in scope.row.visitors" :key="index">
              <div :class="{'visitor-item':index!==0}">{{ visitor.name }}</div>
            </div>
            </template>
        </el-table-column>
        <!-- <el-table-column label="证件类型" width="80">
          <template slot-scope="scope">
            <div v-for="(visitor, index) in scope.row.visitors" :key="index">
              <div :class="{'visitor-item':index!==0}">{{ visitor.identityCardTypeText }}</div>
            </div>
            </template>
        </el-table-column> -->
        <el-table-column label="证件号码" min-width="100">
          <template slot-scope="scope">
            <div v-for="(visitor, index) in scope.row.visitors" :key="index">
              <div :class="{'visitor-item':index!==0}">{{ visitor.identityCard }}</div>
            </div>
            </template>
        </el-table-column>
        <!-- <el-table-column label="手机号" width="120">
          <template slot-scope="scope">
            <div v-for="(visitor, index) in scope.row.visitors" :key="index">
              <div :class="{'visitor-item':index!==0}">{{ visitor.mobile }}</div>
            </div>
            </template>
        </el-table-column> -->
        <template v-if="isInvoice">
          <el-table-column width="100" label="订单总额" prop="paymentDetails.amount">
          </el-table-column>
          <el-table-column width="150" label="支付方式" prop="paymentDetails.paymentChannel">
          </EL-table-column>
          <el-table-column label="支付时间" prop="paymentDetails.time">
          </EL-table-column>
          <el-table-column width="150" label="支付流水" prop="paymentDetails.payNumber">
          </EL-table-column>
          <el-table-column width="100" label="发票状态" prop="invoiceStatusText">
          </EL-table-column>
        </template>
        <template v-else>
          <template v-if="!isFinanceAudit">
          <el-table-column
            prop="note"
            label="备注信息"
            width="80"
            show-overflow-tooltip
            class-name="note"
          >
          </el-table-column>
          <el-table-column width="30">
            <template slot-scope="scope">
              <el-popover
                placement="bottom"
                title="备注信息"
                width="300"
                v-model="scope.row.isEditing"
                popper-class="popper"
                align="center"
              >
                <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  resize="none"
                  v-model="scope.row.note"
                >
                </el-input>
                <div class="popover-btn-container">
                  <el-button type="primary" @click="saveNote(scope.row)"
                    >保存</el-button
                  >
                  <el-button type="primary" plain @click="cancelEdit(scope.row)"
                    >取消</el-button
                  >
                </div>
                <span
                  class="iconfont edit-icon"
                  slot="reference"
                  :class="{
                    'icon-editing': scope.row.isEditing
                  }"
                  @click="enterEdit(scope.row)"
                  >&#xe72f;</span
                >
              </el-popover>
            </template>
          </el-table-column>
        </template>
        <el-table-column prop="createdDate" label="发起时间" min-width="90">
        </el-table-column>
        <el-table-column prop="personCount" label="预约人数" min-width="75">
        </el-table-column>
        <el-table-column prop="statusText" label="状态" min-width="90">
        </el-table-column>
        </template>
        <el-table-column label="取消类型" v-if="isFinanceAudit" min-width="90">
          <template slot-scope="scope">
            <div>{{ cancelStatusText(scope.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" :min-width="isFinanceAudit?'100':'90'">
          <template slot-scope="scope">
            <template v-if="isInvoice">
            <el-button type="text" v-if="scope.row.invoiceStatus==='PENDING'" @click="getApproveInvoice(scope.row)"
              >确认开票</el-button>
            </template>
            <template v-else>
            <el-button type="text" @click="getDetail(scope.row)"
              >详情</el-button
            >
            <template v-if="isFinanceAudit">
              <el-button
                type="text"
                v-if="scope.row.status === 'WAITING_FINANCE_AUDIT'"
                @click.native="financeAuditOfReservation(scope.row, 'FINANCE_PASSED')"
                >财务审核通过</el-button>
              <el-button
                type="text"
                v-if="scope.row.status === 'WAITING_FINANCE_AUDIT'"
                @click="financeAuditOfReservation(scope.row, 'FINANCIAL_AUDIT_FAILED')"
                >财务审核驳回</el-button>
              </template>
            <!-- <el-button
              type="text"
              v-if="scope.row.status !== '已取消'"
              @click="editDetail(scope.row)"
              >编辑</el-button> -->
              <template v-else>
                <el-button
                  type="text"
                  v-if="scope.row.status === 'WAITING_AUDIT'"
                  @click="updateStatus(scope.row, 'APPROVED')"
                  >通过预约</el-button>
                <el-button
                  type="text"
                  v-if="scope.row.status === 'WAITING_AUDIT'"
                  @click="updateStatus(scope.row, 'REJECT_CANCEL')"
                  >驳回预约</el-button>

              </template>
              </template>
          </template>
        </el-table-column>
      </el-table>
    </wt-paged-table>
    <el-dialog v-if="dialogVisibleOfApprove" :title="'审核'+dialogStatusText" :visible.sync="dialogVisibleOfApprove">
      <span>您本次要{{dialogStatusText}}的预约场次为：<span style="font-weight: bold;">{{ approveSelectedRow.date }} {{ approveSelectedRow.time }} {{approveSelectedRow.personCount}}人</span>，请确认是否{{dialogStatusText}}？</span>
          <span slot="footer" class="dialog-footer">
            <template v-if="setStatus==='APPROVED'">
            <el-button type="primary" @click="statusConfirm('BUSINESS')">业务部接待</el-button>
            <el-button type="primary" @click="statusConfirm('EXPERIENCE_HALL')">体验馆接待</el-button>
            </template>
            <el-button type="primary" v-else @click="statusConfirm()">确认驳回</el-button>
            <el-button @click="dialogVisibleOfApprove = false">取 消</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-life-experience-pavilion-reservation-table'

export default {
  name: 'pt-life-experience-pavilion-reservation-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      popoverVisible: false,
      dialogVisibleOfApprove: false,
      approveSelectedRow: null,
      dialogStatusText: null,
      setStatus: null
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 0
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    isInvoice: Boolean,
    isFinanceAudit: Boolean
  },
  methods: {
    cancelStatusText (row) {
      switch (row.cancelStatus) {
        case 'TIME_CANCEL':
          return '场次取消'
        case 'ADMIN_CANCEL':
          return '管理员取消'
        case 'USER_CANCEL':
          return '用户取消'
      }
    },
    getApproveInvoice (row) {
      this.$confirm(
        `您本次要开票的预约场次为：<span style="font-weight: bold;">${row.date} ${row.time} ${row.personCount}人,订单金额为${row.paymentDetails.amount}</span>，请确认是否开票？`,
        {
          confirmButtonText: `开票`,
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        let data = {
          id: row.id,
          invoiceStatus: 'APPROVED'
        }
        this.$store.dispatch('updateInvoiceStatus', data).then(res => {
          this.$message.success('确认开票成功')
          this.$emit('getTableData', this.page)
        }).catch(err => {
          this.$message.error(err || '确认开票失败')
        })
      })
    },
    financeAuditOfReservation (row, status) {
      let statusText = status === 'FINANCE_PASSED' ? '通过财务审核' : '驳回财务审核'
      this.$confirm(
        `您正在审核退款操作，预约场次为：<span style="font-weight: bold;">${row.date} ${row.time} ${row.personCount}人,订单金额为${row.paymentDetails.amount}<span style="font-weight: bold;">，请确认是否${statusText}？`,
        {
          confirmButtonText: `确认`,
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        let data = {
          id: row.id,
          status: status
        }
        this.$store.dispatch('financeAuditOfReservation', data).then(res => {
          this.$message({
            type: 'success',
            message: `已${statusText}`
          })
          this.$emit('getTableData', this.page)
        }).catch(err => {
          this.$message.error(err || '更新状态失败')
        })
      })
    },
    updateStatus (row, status) {
      this.dialogStatusText = status === 'APPROVED' ? '通过' : '驳回'
      this.approveSelectedRow = row
      this.setStatus = status
      this.dialogVisibleOfApprove = true
    },
    statusConfirm (type) {
      let data = {
        id: this.approveSelectedRow.id,
        status: this.setStatus
      }
      if (this.setStatus === 'APPROVED') {
        data.receiveType = type
      }
      this.$store
        .dispatch('updateReservationStatus', data)
        .then(() => {
          this.$message({
            type: 'success',
            message: `已${this.dialogStatusText}`
          })
          this.dialogVisibleOfApprove = false
          this.getTableData(this.page)
        })
        .catch(err => {
          this.dialogVisibleOfApprove = false
          this.$message.error(err || '更新状态失败')
        })
    },
    cancelEdit (row) {
      row.isEditing = false
      setTimeout(() => {
        row.note = row.originalNote
      }, 200)
    },
    saveNote (row) {
      let data = {
        id: row.id,
        note: row.note
      }
      // 保存操作
      this.$store
        .dispatch('updateReservationNote', data)
        .then(() => {})
        .catch(err => {
          row.note = row.originalNote
          this.$message.error(err || '保存备注失败')
        })
      row.isEditing = false
    },
    enterEdit (row) {
      row.originalNote = row.note
      row.isEditing = true
    },
    getDetail (row) {
      this.$router.push('/reservation-detail/' + row.id + `?isFinanceAudit=${this.isFinanceAudit}`)
    },
    editDetail (row) {
      this.$router.push('/reservation-detail/' + row.id + '?edit=true')
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    objectSpanMethod ({ row, column, columnIndex }) {
      let arr = [0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
      if (arr.indexOf(columnIndex) !== -1) {
        return {
          rowspan: column.rowSpan !== 0 ? row.rowspan : 1,
          colspan: 1
        }
      }
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    }
  }
}
</script>

<style scoped lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.edit-icon {
  cursor: pointer;
  color: #f1cb9a;
  display: none;
  margin-right: 0 !important;
}
.el-table__body tr:hover {
  .edit-icon {
    display: inline-block;
  }
}
.popover-btn-container {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}
.visitor-item{
  padding-top: 10px;
}
.icon-editing {
  display: inline-block !important;
}
.el-button{
  margin-right: 10px;
}
.el-button + .el-button{
  margin-left: 0;
}
</style>
<style lang="less">
.popper {
  z-index: 9 !important;
  .el-popover__title {
    text-align: center;
  }
}
</style>
<style lang="less" module>
.life-experience-pavilion-reservation-table{
  :global{
  .el-table .cell{
    padding-left: 0.08rem!important;
    padding-right: 0.08rem!important;
  }
  }
}
</style>
